import React, { Component, ErrorInfo, ReactNode } from 'react';
import styled from 'styled-components';
import { Size } from 'lib/styles';

const Container = styled.div`
  margin: ${Size.large} auto;
  max-width: 100%;
  text-align: center;
`;

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(_error: Error): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error('Error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Container>
          <h1 style={{ fontSize: '60px' }}>Error</h1>
          <p style={{ fontSize: '30px' }}>We are working hard to resolve it.</p>
        </Container>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
